import FashionNovaHeader from "../components/header/header";
import HeroTwoPanel from "../components/hero/hero";

import { useDispatch, useSelector } from "react-redux";
import FeatureBanner from "../components/feature/featureBanner";
import ProductGrid from "../components/bestSeller/bestSeller";
import ShopTheLatest from "../components/latest/latest";
import Footer from "../components/footer/footer";
import { Helmet } from "react-helmet-async";
import Newsletter from "../components/newsletter/newsletter";
import TrendReport from "../components/trendReport/trendReport";
import { loadUser } from "../redux/reducers/userSlice";
import { useEffect } from "react";

const Homepage = () => {
  const dispatch = useDispatch();

  const { isAuthenticated, loading, user } = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(loadUser());
  }, [dispatch]);

  useEffect(() => {
    if (!loading) {
      if (isAuthenticated) {
      } else {
      }
    }
  }, [loading, isAuthenticated, user]);
  return (
    <>
      <Helmet>
        <title>Ninety One | Streetwear & Fashion Store in Nairobi, Kenya</title>
      </Helmet>
      <FashionNovaHeader />
      {/* <HeroTwoPanel /> */}
      <FeatureBanner />
      <TrendReport division="Women" title="Trending" />
      <ProductGrid division="Women" />
      <ShopTheLatest division="Women" />
      <Newsletter />
      <Footer />
    </>
  );
};

export default Homepage;
